<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">Projeto</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>Campos com * são de preenchimento obrigatório</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>* Nome</label>
                    <input
                      v-model="viewModel.name"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>Endereço</label>
                    <input
                      v-model="viewModel.address"
                      class="form-control"
                      type="text"
                      placeholder="Digite o endereço"
                    />
                  </div>
                </div>
                                <div
                  class="col-sm-6 col-md-2 col-lg-2 col-xl-1"
                  title="Informa se o usuário está ativo para utilizar o sistema."
                >
                  <label for>GAAU</label>
                  <b-form-checkbox
                    v-model="viewModel.isGaau"
                    name="check-button"
                    switch
                  >
                    Sim
                  </b-form-checkbox>
                </div>
               </div>
            </div>
            <div class="btn-toolbar mb-3 ml-3" role="toolbar">
              <div class="btn-group" role="group">
                <button class="btn btn-success mr-2" type="submit">
                  Salvar
                </button>
              </div>
              <div class="btn-group" role="group">
                <button
                  class="btn btn-secondary"
                  type="reset"
                  @click="$router.go(-1)"
                >
                  Voltar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import ProjectService from "../../servico/ProjectService";

export default {
  name: "NewProject",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      viewModel: {
        id: this.$store.getters.emptyGuid,
        address: "",
        name: "",
        isGaau: false
      }
    };
  },
  created() {
    let id = this.$route.params.id;
    if (id) this.Get(id);
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.viewModel.id !== this.$store.getters.emptyGuid) this.Edit();
      else this.New();
    },

    Get(usuarioId) {
      this.loading = false;

      ProjectService.Get(usuarioId)
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    New() {
      this.loading = false;

      ProjectService.New(this.viewModel)
        .then(() => {
          this.loading = false;
          this.$router.go(-1);
          this.$notify({
            data: ["Projeto cadastrado com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Edit() {
      this.loading = false;

      ProjectService.Edit(this.viewModel)
        .then(() => {
          this.loading = false;
          this.$router.go(-1);
          this.$notify({
            data: ["Projeto editado com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
